var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLines1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 200,
    viewBox: "0 0 328 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164 102.426L367.849 94.9824V108.725L164 104.144V102.426Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 104.142L-39.8485 111.014V97.271L164 102.425V104.142Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.429 102.996L155.985 -100.853H169.727L165.147 102.996H163.429Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.145 102.996L172.016 306.845H158.273L163.427 102.996H165.145Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.475 102.771L237.933 -87.139L250.536 -81.6592L165.05 103.456L163.475 102.771Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.05 103.455L90.067 293.137L77.4642 287.657L163.475 102.77L165.05 103.455Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.472 103.218L78.5846 -82.2654L91.2811 -87.5245L165.059 102.56L163.472 103.218Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.062 102.561L249.42 288.264L236.724 293.523L163.475 103.219L165.062 102.561Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.405 102.594L313.811 241.473L304.094 251.191L163.19 103.808L164.405 102.594Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.191 103.809L14.1895 -35.475L23.907 -45.1925L164.406 102.595L163.191 103.809Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.22 102.465L355.401 173.598L350.142 186.294L163.563 104.052L164.22 102.465Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.562 104.052L-27.3998 32.3908L-22.1407 19.6942L164.219 102.465L163.562 104.052Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.594 102.594L302.474 -46.813L312.191 -37.0955L164.809 103.808L163.594 102.594Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.812 103.807L25.5274 252.809L15.8099 243.091L163.597 102.593L164.812 103.807Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.783 102.463L349.266 17.5763L354.525 30.2728L164.44 104.05L163.783 102.463Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.441 104.052L-21.2611 188.41L-26.5202 175.714L163.784 102.465L164.441 104.052Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.113 102.436L365.637 134.025L363.015 147.515L163.785 104.122L164.113 102.436Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.782 104.124L-37.633 71.973L-35.0108 58.4828L164.11 102.438L163.782 104.124Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.436 102.891L195.025 -98.633L208.515 -96.0108L165.122 103.219L163.436 102.891Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.122 103.218L132.971 304.633L119.481 302.011L163.436 102.89L165.122 103.218Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.53 102.675L272.856 -69.5384L284.182 -61.7545L164.945 103.648L163.53 102.675Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.947 103.647L55.1485 275.536L43.8229 267.752L163.531 102.674L164.947 103.647Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.44 103.12L115.504 -95.1529L128.971 -97.8928L165.123 102.777L163.44 103.12Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.123 102.776L212.497 301.163L199.03 303.903L163.439 103.119L165.123 102.776Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.478 102.678L284.64 267.514L273.247 275.199L163.053 103.639L164.478 102.678Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.053 103.638L43.3651 -61.518L54.7582 -69.2028L164.477 102.677L163.053 103.638Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.318 102.524L338.413 208.828L330.828 220.288L163.37 103.956L164.318 102.524Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.367 103.956L-10.4121 -2.82625L-2.82701 -14.286L164.315 102.523L163.367 103.956Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.678 102.527L328.514 -17.6354L336.199 -6.24228L164.639 103.951L163.678 102.527Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.642 103.95L-0.514099 223.637L-8.19888 212.244L163.681 102.526L164.642 103.95Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.887 102.439L362.159 54.5036L364.899 67.9703L164.229 104.122L163.887 102.439Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.228 104.124L-34.1585 151.498L-36.8984 138.032L163.886 102.441L164.228 104.124Z",
    fill: "#EDF0FA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines1);
export default __webpack_public_path__ + "static/media/lines (1).1ba582c5d57658d36764729d454cfe21.svg";
export { ForwardRef as ReactComponent };